export default "__VITE_ASSET__VQKZbLld__"